import React, { useEffect, useState } from "react";
import queryString from "query-string";
import { Location } from "history";
import { ReactElement } from "react";
import { StaticContext, useHistory } from "react-router";
import { RouteComponentProps } from "react-router-dom";
import { Box, Button, createTheme, CssBaseline, Grid, useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import { Typography, Skeleton } from '@mui/material';
import WhiteInosio from "../../icons/whiteinosio.svg"
import WorkSans from '../../fonts/Work_Sans/WorkSans-Regular.ttf'
import { makeStyles, ThemeProvider } from '@mui/styles';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthState, getAccountActivationDetails, setGlobalError } from '../../shared/sagas/auth/authSlice';
import { getResidentDetails } from '../payments/sagas/residentpaymentsSlice';
import { RightContainer } from "../../components/RightContainer";
import BMWHelveticaBold from "../../fonts/BMWHelvetica-Bold/BMWHelvetica-Bold.otf";

//This is how we add self Hosted fonts
const theme = createTheme({
  typography: {
    fontFamily: 'BMWHelveticaBold',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'BMWHelveticaBold';
          font-style: normal;
          font-display: swap;
          font-weight: 700;
          src: local('BMWHelveticaBold'), url(${BMWHelveticaBold}) format('otf');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
      `,
    },
  },
});

type LocationState = {
  from: Location;
};

const useStyles = makeStyles((theme) => ({
  rootContainer: {
    height: "100vh",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    borderRadius: "24px",
  },
  btnSubmitStyle: {
    background: "rgba(211, 211, 211, 1) !important",
    color: "#Fff !important",
    borderRadius: "24px !important",
    padding: "6px 17px !important",
    marginBottom: "60px !important",
    width: "76px",
    height: "49px"
  },
  btnSubmitStyleactive2: {
    background: "#A2DBFA !important",
    color: "#Fff !important",
    borderRadius: "24px !important",
    padding: "6px 17px !important",
    marginBottom: "60px !important",
    width: "76px",
    height: "49px"
  },
  btnSubmitStyleactive: {
    background: "rgba(57, 162, 219, 1) !important",
    color: "#Fff !important",
    borderRadius: "24px !important",
    padding: "6px 17px !important",
    marginBottom: "60px !important",
    width: "76px",
    height: "49px"
  },
  leftContainer: {
    borderRadius: "24px 0px 0px 24px",
    background: "#ffffff",
    // width: "42%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
  },
  styleLink: {
    textDecoration: "none",
  },
  activateAccountContainer: {
    height: "100vh",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    background: "#FFFFFF",
    borderRadius: "24px",
  },
  rightContainer: {
    background: "#053742",
    width: "59%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    // margin: "0 auto",
    height: "100%",
  },
  leftPart: {
    borderRadius: "24px 0px 0px 24px",
    background: "#FFFFFF",
    // width: "41%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
  },
  inosioBrandContainer: {
    display: "flex",
    flexDirection: "row",
    marginBottom: "30px",
    width: "340px",
    padding: '10px'
  },
  brandTextContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "36px",
  },
  brandText: {
    fontFamily: "BMWHelvetica75",
    fontWeight: 700,
    fontSize: "24px",
  },
  residentInfoContainer: {
    background: "#FFFFFF",
    boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.1)",
    borderRadius: "20px",
    width: "340px",
    height: "120px",
  },
  residentNameContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "space-between",
    justifyContent: "space-between",
  },
  instructionsContainer: {
    background: "#FFFFFF",
    boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.1)",
    borderRadius: "20px",
    width: "340px",
    height: "97px",
    marginTop: "30px",
  },
  instructionsInnerContainer: {
    fontFamily: `'"${WorkSans}"'`,
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "21px",
    marginLeft: "16px",
    marginTop: "17px",
  },

  continueButtonContainer: {
    width: "340px",
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginTop: "30px",
  },
  pageIntroContainer: {
    background: "#053742",
    width: "59%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
  },
  globalError: {
    display: "flex",
    flexDirection: "row",
    marginBottom: "30px",
    borderTop: "2px  solid #DB3939",
    borderRadius: "24px",
    padding: "12px 20px",
    width: "340px",
    height: "49px",
  },
}));

export default function ActivateAccount(props: RouteComponentProps<{}, StaticContext, LocationState>): ReactElement {
  const { location } = props;
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [tokenFromQuery, setTokenFromQuery] = useState("");
  const { accountActivationDetails, validateTokenErrorResponse } = useSelector(selectAuthState);
  const matches900 = useMediaQuery("(max-width:900px)");
  const matches1200 = useMediaQuery("(max-width:1200px)");

  useEffect(() => {
    dispatch(getResidentDetails());
  }, [dispatch]);

  useEffect(() => {
    const { activationToken } = queryString.parse(location.search);
    if (activationToken?.length !== 0) {
      setTokenFromQuery(activationToken);
      dispatch({
        type: getAccountActivationDetails.type,
        payload: {
          activationToken: activationToken,
        },
      });
    }
  }, [location, dispatch]);

  useEffect(() => {
    if (validateTokenErrorResponse && Object.keys(validateTokenErrorResponse).length !== 0) {
      let message = ''
      if (validateTokenErrorResponse?.statusCode === 403) {
        message = "The activation token supplied has already been used. If you feel this is an error, please contact support.";
      } else if (validateTokenErrorResponse?.statusCode === 401) {
        message = "The activation token has expired. Please contact support to get a new one.";
      } else {
        message = validateTokenErrorResponse?.message || "Something went wrong";
      }

      dispatch({
        type: setGlobalError.type,
        payload: { message },
      });

      history.push("/");
    }
  }, [validateTokenErrorResponse]);

  useEffect(() => {
    if (accountActivationDetails &&
      ["companystaff", "vendor", "owner"].includes(accountActivationDetails.EntityType?.toLocaleLowerCase())
      ) {
      history.push("/completeregistration", {
        token: tokenFromQuery,
      });
    }
  }, [accountActivationDetails, history, tokenFromQuery]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className={classes.rootContainer}>
        <Grid sx={{ flexDirection: "column" }} className={classes.leftContainer}>
          <div className={classes.leftPart}>
            {accountActivationDetails && Object.keys(accountActivationDetails).length !== 0 ? (
              <React.Fragment>
                <div className={classes.inosioBrandContainer}>
                  <div>
                    <img src={WhiteInosio} style={{ width: "130px", height: "130px" }} alt="logo" />
                  </div>
                  <div className={classes.brandTextContainer}>
                    <Typography sx={{ fontFamily: 'BMWHelveticaBold', fontWeight: '700', fontSize: '24px', fontStyle: 'normal', lineHeight: '30px', color: '#14142B' }} >
                      Welcome to
                      <br />
                      {accountActivationDetails && Object.keys(accountActivationDetails).length !== 0 ? accountActivationDetails.CompanyDbaName : ""}
                    </Typography>
                  </div>
                </div>
                <div className={classes.residentInfoContainer}>
                  <div className={classes.residentNameContainer}>
                    <div>
                      <Typography
                        style={{
                          fontFamily: "Work Sans",
                          fontWeight: 700,
                          fontSize: "18px",
                          lineHeight: "23px",
                          marginLeft: "16px",
                          marginTop: "9px",
                          marginBottom: "9px",
                        }}
                      >
                        {accountActivationDetails && Object.keys(accountActivationDetails).length !== 0 ? `${accountActivationDetails?.FirstName || ''} ${accountActivationDetails?.MiddleName || ''} ${accountActivationDetails?.LastName || ''}` : ""}
                      </Typography>
                    </div>
                  </div>
                  <div>
                    <Typography
                      style={{
                        fontFamily: "Work Sans",
                        fontWeight: 400,
                        fontSize: "18px",
                        lineHeight: "21px",
                        marginLeft: "16px",
                      }}
                    >
                      {accountActivationDetails ? (
                        `
                            ${accountActivationDetails?.Address?.Line1}
                            
                            ${accountActivationDetails?.Address?.Line2}
                            `
                      ) : (
                        <></>
                      )}
                    </Typography>
                    <Typography
                      style={{
                        fontFamily: "Work Sans",
                        fontWeight: 400,
                        fontSize: "18px",
                        lineHeight: "21px",
                        marginLeft: "16px",
                      }}
                    >
                      {accountActivationDetails ? (
                        `
                            ${accountActivationDetails?.Address?.City},
                            ${accountActivationDetails?.Address?.State}
                            ${accountActivationDetails?.Address?.Zip}
                            `
                      ) : (
                        <></>
                      )}
                    </Typography>
                  </div>
                </div>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className={classes.inosioBrandContainer}>
                  <Skeleton variant="rectangular" width={340} height={97} style={{ borderRadius: "24px" }} />
                </div>
                <div className={classes.residentInfoContainer}>
                  <Skeleton variant="rectangular" width={340} height={120} animation="wave" style={{ borderRadius: "24px" }} />
                </div>
              </React.Fragment>
            )}

            <Box mt={4} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', width: "340px" }}>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontFamily: "Work Sans",
                  fontSize: "18px",
                  lineHeight: "21px",
                }}
                p={1}
              >
                Does this information look correct?
              </Typography>
              <Grid pt={1} container direction="row" spacing={2}>
                <Grid item>
                  <Link to="/" className={classes.styleLink}>
                    <Button
                      onClick={(e: any) => { }}
                      disabled={!(accountActivationDetails && Object.keys(accountActivationDetails).length !== 0)}
                      className={accountActivationDetails && Object.keys(accountActivationDetails).length !== 0 ? classes.btnSubmitStyleactive2 : classes.btnSubmitStyle}
                    >
                      No
                    </Button>
                  </Link>
                </Grid>
                <Grid item>
                  <Link
                    className={classes.styleLink}
                    to={{
                      pathname: "/completeregistration",
                      state: {
                        token: tokenFromQuery,
                      },
                    }}
                  >
                    <Button
                      onClick={(e: any) => { }}
                      disabled={!(accountActivationDetails && Object.keys(accountActivationDetails).length !== 0)}
                      className={accountActivationDetails && Object.keys(accountActivationDetails).length !== 0 ? classes.btnSubmitStyleactive : classes.btnSubmitStyle}
                      id="correct-info"
                    >
                      Yes
                    </Button>
                  </Link>
                </Grid>
              </Grid>
            </Box>
          </div>
        </Grid>

        {!(matches900 && matches1200) ? (
          <Grid className={classes.rightContainer}>
            <RightContainer />
          </Grid>
        ) : (
          <></>
        )}
      </div>
    </ThemeProvider>
  );
}
